import React from 'react'
import PropTypes from 'prop-types'
import useForm from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'

import {
  TextField,
  Paper,
  Box,
  Divider,
  Button,
  makeStyles,
} from '@material-ui/core'

import InputCep from 'components/InputCep'
import schemas from '../../schemas'

import styles from './styles'

const useStyles = makeStyles(styles)

const SettingsAddressForm = ({ address, onSubmit, handleClose }) => {
  const classes = useStyles()
  const { register, handleSubmit, setValue, errors } = useForm({
    validationSchema: schemas.address,
    defaultValues: { ...address, complement: address.complement || '' },
  })

  const handleRequestCEP = data => {
    if (!data) {
      return
    }

    setValue('city', data.address.city)
    setValue('state', data.address.state)
    setValue('street', data.address.street)
    setValue('neighborhood', data.address.neighborhood)
  }

  return (
    <Paper>
      <form onSubmit={handleSubmit(onSubmit)} id="settings-address-form">
        <Box p={2}>
          <RHFInput
            as={
              <InputCep
                label="CEP"
                margin="dense"
                onRequest={handleRequestCEP}
                error={!!errors.postalCode}
                helperText={
                  errors && errors.postalCode && errors.postalCode.message
                }
                fullWidth
              />
            }
            name="postalCode"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Rua"
                margin="dense"
                error={!!errors.street}
                helperText={errors && errors.street && errors.street.message}
                fullWidth
              />
            }
            name="street"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Número"
                margin="dense"
                error={!!errors.number}
                helperText={errors && errors.number && errors.number.message}
                fullWidth
              />
            }
            name="number"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Bairro"
                margin="dense"
                error={!!errors.neighborhood}
                helperText={
                  errors && errors.neighborhood && errors.neighborhood.message
                }
                fullWidth
              />
            }
            name="neighborhood"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Cidade"
                margin="dense"
                error={!!errors.city}
                helperText={errors && errors.city && errors.city.message}
                fullWidth
              />
            }
            name="city"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Estado"
                margin="dense"
                error={!!errors.state}
                helperText={errors && errors.state && errors.state.message}
                fullWidth
              />
            }
            name="state"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Complemento (opcional)"
                margin="dense"
                error={!!errors.complement}
                helperText={
                  errors && errors.complement && errors.complement.message
                }
                fullWidth
              />
            }
            name="complement"
            register={register}
            setValue={setValue}
          />
        </Box>
        <Divider />
        <Box p={2}>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            form="settings-address-form"
            className={classes.btnSave}
          >
            Salvar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => handleClose(false)}
          >
            Cancelar
          </Button>
        </Box>
      </form>
    </Paper>
  )
}

SettingsAddressForm.propTypes = {
  address: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default SettingsAddressForm
